import React from "react";

const Pagination = ({ page, totalPages, onPageChange }) => (
  <div className="flex items-center justify-center gap-4 mt-4">
    <button
      onClick={() => onPageChange(page - 1)}
      disabled={page <= 1}
      className="text-sm text-textMuted hover:text-textPrimary disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
    >
      ← Prev
    </button>
    <span className="text-sm text-textMuted">{page}</span>
    <button
      onClick={() => onPageChange(page + 1)}
      disabled={page >= totalPages}
      className="text-sm text-textMuted hover:text-textPrimary disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
    >
      Next →
    </button>
  </div>
);

export default Pagination;
